<div class="card bg-dark text-white card-banner-list-item-promo" [ngClass]="{static: static}" *transloco="let t"
  [style.--primaryColourRgb]="primaryColourRgb">
  <div class="card-img-overlay-color"></div>

  @if (content.images | imageForRole:'hero':true; as cover) {
    <img class="card-img"
      [src]="cover | imageUrl:imageTransformations"
      [alt]="cover.alt_text">
  }

  <div class="card-img-overlay" [style.--primaryColourRgb]="primaryColourRgb">
    <div class="top-part">
      <h5 class="card-title h5">
        <!-- 324 <span class="vertical-splitter"></span>  -->
        {{content.title ?? t(content.titleTranslationKey)}}
      </h5>

      <div class="cta-holder">
        @if (content.user) {
          <span>
            <!-- For users/people -->
            <div class="user-holder">
              <img class="user-img"
                [src]="content.user | userAvatar"
                [alt]="content.user.fname+' '+content.user.lname">
              <div class="user-info">
                <p class="user-name">{{content.user.fname+' '+content.user.lname}}</p>
                <p class="user-subtitle">{{content.user.job_title}}</p>
              </div>
            </div>
          </span>
        } @else {
          <!-- For Brands -->
          @if (content.meta?.logo_banner) {
            <span>
              <img class="img-responsive logo" [src]="content.meta.logo_banner | imageUrl" [alt]="content.title+' logo'">
            </span>
          }
        }
      </div>
    </div>
    <div class="bottom-part mt-3">
      <p class="card-title h5">
        {{content.subtitle ?? t(content.subtitleTranslationKey)}}
      </p>
      @if (content?.rating === 0 || content?.rating || content?.meta?.avatars_count) {
        <div class="info-bar">
          @if (content?.rating === 0 || content?.rating) {
            <div class="rating">
              {{content.rating}}<i class="ml-2 fa-solid fa-star"></i>
            </div>
          }
          @if (content?.meta?.avatars_count) {
            <span class="vertical-splitter"></span>
          }
          @if (content?.meta?.avatars_count) {
            <div class="user-counter">
              @for (avatar of randomAvatars; track avatar) {
                <img class="user-img" [src]="avatar" alt="A person">
              }
              <span class="ml-2">{{content.meta.avatars_count.number}} {{content.meta.avatars_count.titleText ?? t(content.meta.avatars_count.titleTranslationKey)}}</span>
            </div>
          }
        </div>
      }
      <p class="card-text">
        {{content.description ?? t(content.descriptionTranslationKey)}}
      </p>
      @if (content?.meta?.statistics?.length) {
        <div class="statistics">
          @for (statistic of content.meta.statistics; track statistic) {
            <div class="num-holder">
              <p>{{statistic.titleText ?? t(statistic.titleTranslationKey)}}</p>
              <span>{{statistic.number}}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>